export default __webpack_public_path__ + "static/media/View3_Dark.ff074546.svg";